<div class="tr md-no-proxy layout-row layout-align-start-center">

  <!--Team Name-->
  <div class="td flex layout-row layout-align-start-center">
    <span class="text-ellipsis">{{ team.name }}</span>
    <bringoz-icon iconName="team" class="margin-left-5"
                  [ngbTooltip]="tooltipTmpl"
                  (shown)="getTeamAgentIds()"
                  fill="#7E7E7E"
                  openDelay="300"
                  triggers="hover"
                  container="body">

    </bringoz-icon>

    <ng-template #tooltipTmpl>
      <div class="layout-column">
        <span *ngIf="isLoadingAgentIds">{{ 'Loading' | translate }}...</span>
        <span *ngIf="!isLoadingAgentIds">{{agentIds.length}}</span>
      </div>
    </ng-template>
  </div>

  <!--External ID-->
  <div class="td flex layout-row layout-align-start-center">
    <span class="text-ellipsis">{{ team.externalId }}</span>
  </div>

  <!--Admin-->
  <!--  <div class="td flex layout-row layout-align-start-center">-->
  <!--  </div>-->

  <!--Agents-->
  <!--  <div class="td flex layout-row layout-align-start-center">-->
  <!--  </div>-->

  <!--Description-->
  <div class="td flex layout-row layout-align-start-center">
    <span class="text-ellipsis" [ngbTooltip]="team.description" triggers="hover"
          container="body">{{ team.description }}</span>
  </div>

  <!--Created At-->
  <div class="td flex layout-row layout-align-start-center">
    {{ team | bringozFullDate: 'createdAt' }}
  </div>

  <!--Updated At-->
  <div class="td flex layout-row layout-align-start-center">
    {{ team | bringozFullDate: 'updatedAt' }}
  </div>

  <!--Actions-->
  <div class="td flex-5 layout-row layout-align-start-center">
    <div *ngIf="allowEdit">
      <bringoz-button *ngxPermissionsOnly="'teams.update'"
                      type="tertiary"
                      (onClick)="editTeamEvent.emit(team)">
        <bringoz-icon iconName="edit-outline" classSize="lg" fill="#424242"></bringoz-icon>
      </bringoz-button>
    </div>

    <div *ngIf="allowDelete" class="margin-left-5">
      <bringoz-button *ngxPermissionsOnly="'teams.delete'"
                      type="tertiary"
                      (onClick)="deleteTeamEvent.emit(team)">
        <bringoz-icon iconName="trash" classSize="lg" fill="#424242"></bringoz-icon>
      </bringoz-button>
    </div>

  </div>
</div>
